import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["GTMTrackPageView"] */ "/app/src/core/components/google-tag-manger-page-views.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleTagManager"] */ "/app/src/core/components/google-tag-manger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteOverlayWrapper"] */ "/app/src/core/components/site-overlay-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrustpilotModule"] */ "/app/src/shared/blocks/trustpilot-module/trustpilot-module.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ServiceMenu"] */ "/app/src/shared/components/header/desktop-header/service-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/header/header-sticky-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileHeader"] */ "/app/src/shared/components/header/mobile-header/mobile-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderStoreProvider"] */ "/app/src/shared/components/header/stores/header-store-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion","AccordionItem","AccordionTrigger","AccordionContent"] */ "/app/src/shared/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DialogTitle","DialogDescription","DialogClose"] */ "/app/src/shared/ui/dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExternalSvg"] */ "/app/src/shared/ui/media/external-svg.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/shared/ui/media/image-imgix.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NavigationMenu","NavigationMenuList","NavigationMenuItem","NavigationMenuTrigger","NavigationMenuContent"] */ "/app/src/shared/ui/navigation-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsList","TabsTrigger","TabsContent"] */ "/app/src/shared/ui/tabs.tsx");
